export const AF3_INVALID_COORDINATES = {
  VALUE: '32767',
};

export const AF3_INVALID_COORDINATES_0 = {
  VALUE: '32767.0',
};
